import Cookies from 'js-cookie';
/**
 * 获取通用header配置
 */
export const getCommonHeader = () => {
    return {
        deviceType: '1',
        token: Cookies.get('token') || '',
        userId: Cookies.get('userId') || '',
        spaceId: Cookies.get('spaceId') || '',
        deviceId: window.deviceId,
        'x-toca-appkey': 'com.ly.web',
    };
};
